import script from "./LedDisplayDataInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./LedDisplayDataInformation.vue?vue&type=script&lang=ts&setup=true"

import "./LedDisplayDataInformation.vue?vue&type=style&index=0&id=521d62d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521d62d6"]])

export default __exports__